import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { UsersService } from '../../../services/users.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-delete-department',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './delete-department.component.html',
  styleUrl: './delete-department.component.scss'
})
export class DeleteDepartmentComponent {
  @Input() departmentData: any;
  @Output() closeDialog = new EventEmitter();
  @Output() reload = new EventEmitter();

  btnLoading = false;

  constructor(
    private api: UsersService,
    private messageService: MessageService,
    private localStorage: LocalStorageService
  ) { }

  handleDelete() {
    this.btnLoading = true;
    const payload = {
      organization_id: this.localStorage.getOrganizationId(),
      dept_id: this.departmentData.dept_id,
    };

    this.api.deleteDepartment(payload).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Department deleted successfully' });
        this.reload.emit();
        this.closeDialog.emit();
      },
      error: (error: any) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error.error.message });
        this.btnLoading = false;
      }
    });
  }

  handleCloseDialog() {
    this.closeDialog.emit();
  }
}
